const watermark = {
  name: 'watermark',
  fn: (el, binding) => {
    function addWaterMarker(str, parentNode, font, textColor) {
      // 水印文字，父元素，字体，文字颜色
      var can = document.createElement('canvas')
      parentNode.appendChild(can)
      can.width = 260
      can.height = 120
      var cans = can.getContext('2d')
      cans.rotate((-12 * Math.PI) / 180)
      cans.font = '15px serif'
      cans.fillStyle = 'rgba(150, 150, 150, 0.6)'
      // cans.textAlign = 'left'
      // cans.textBaseline = 'Middle'
      const w = can.width / 8
      const h = can.height
      cans.fillText('中国医学科学院医学信息研究所', w, h)
      // cans.fillText('医学信息研究所 图书馆', w, h + 16)
      parentNode.style.backgroundImage =
        'url(' + can.toDataURL('image/png') + ')'
      parentNode.removeChild(can)
      if (!binding.value.show) parentNode.style.backgroundImage = ''
    }
    addWaterMarker(
      '中国医学科学院 北京协和医学院\n医学信息研究所 图书馆',
      // binding.value.text,
      el,
      binding.value.font,
      binding.value.textColor
    )
  }
}

export default watermark
